import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedTitleComponent } from './shared-title.component';



@NgModule({
  declarations: [SharedTitleComponent],
  imports: [
    CommonModule
  ],exports:[SharedTitleComponent]
})
export class SharedTitleModule { }
